import { useSelector, shallowEqual } from "react-redux";
import FidelityCardNumberInput from "app/pages/.shared/FidelityCardNumberInput";
import { getFlightInboundAirlineCode } from "app/pages/Booking/bookingSelectors";
import { getLoyalty } from "app/reducers/brandSelector";

const mapStateToProps = state => {
	return {
		airlineCode: getFlightInboundAirlineCode(state),
		resolution: state.resolution,
		loyalty: getLoyalty(state),
	};
};

const FidelityCardNumberInputContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <FidelityCardNumberInput {...props} {...stateProps} />;
};

export default FidelityCardNumberInputContainer;
